import { stringToNumberArray } from '@/utils/formats';
import { toYuan } from '@/utils/number';

export default function(cardTypeInfo, card) {
  const [cardTypeIdAndTypeAndName, cardChargeInfo] = cardTypeInfo;
  const [card_type_id, card_type_name] = stringToNumberArray(cardTypeIdAndTypeAndName);
  const [
    card_name,
    card_charge_type_id,
    is_number_limit,
    expire_number,
    expire_days,
    price,
    is_disable_column,
  ] = stringToNumberArray(cardChargeInfo);

  const priceYuan = toYuan(price);

  Object.assign(card,{
    card_type_id,
    card_type_name,
    card_name,
    card_charge_type_id,
    is_number_limit,
    is_disable_column,
    expire_number: toYuan(expire_number),
    expire_number_default: toYuan(expire_number),
    expire_days,
    expire_days_default: expire_days,
    store_limit_expire_days: expire_days,
    price: priceYuan,
    actual_payment: priceYuan,
  });
}
